import { gqlProfileStatusSearchEnum } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { SelectOption } from '../types';

export const useProfileStatusOptions = (): Array<SelectOption> => {
  const { t } = useTranslation();

  return [
    { value: gqlProfileStatusSearchEnum.CURRENT, label: t('common:profile.status.currentClients') },
    { value: gqlProfileStatusSearchEnum.FORMER, label: t('common:profile.status.formerClients') },
    { value: gqlProfileStatusSearchEnum.FORMER_AND_CURRENT, label: t('common:profile.status.currentAndFormerClients') },
    { value: gqlProfileStatusSearchEnum.ROSTER_HIDDEN, label: t('common:profile.status.rosterHidden') },
    {
      value: gqlProfileStatusSearchEnum.ROSTER_AND_SEARCH_HIDDEN,
      label: t('common:profile.status.rosterAndSearchHidden'),
    },
  ];
};
